const urlencode = (str: string): string => {
    str = (str + '').toString()

    return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
        .replace(/%20/g, '+')
}

const httpBuildQuery = (formdata: object, numericPrefix?: number, argSeparator?: string): string => {
    let value
    let key
    const tmp: string[] = []

    const httpBuildQueryHelper = (name: string, val: any, separator: string): string => {
        let k
        const tmpParameter: string[] = []
        if (val === true) {
            val = '1'
        } else if (val === false) {
            val = '0'
        }
        if (val != null) {
            if (typeof val === 'object') {
                for (k in val) {
                    if (val[k] != null) {
                        tmpParameter.push(httpBuildQueryHelper(name + '[' + k + ']', val[k], separator))
                    }
                }
                return tmpParameter.join(separator)
            } else if (typeof val !== 'function') {
                return urlencode(name) + '=' + urlencode(val)
            } else {
                throw new Error('There was an error processing for httpBuildQuery().')
            }
        } else {
            return ''
        }
    }
    if (formdata) {
        Object.keys(formdata).forEach(formkey => {
            value = formdata[formkey]
            key = numericPrefix && !isNaN(Number(formkey)) ? String(numericPrefix) + formkey : formkey
            if (!argSeparator) {
                argSeparator = '&'
            }
            const query = httpBuildQueryHelper(key, value, argSeparator)
            if (query !== '') {
                tmp.push(query)
            }
        })
    }

    return tmp.join(argSeparator)
}

export default httpBuildQuery
